import React from "react";
import "./Modals.scss";

// Components
import { faCircleXmark, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonHeader, IonModal } from "@ionic/react";
import { ModalButtons } from "./ModalButtons";

// Context
import { useTranslation } from "react-i18next";
import { useSettings } from "../../contexts/SettingsContext";

interface ModalConfirmationProps {
  isOpen: boolean;
  onDidDismiss?: () => any;
  closeModal?: () => any;
  classModifiers?: string;
  background?: string;
  heading?: any;
  text?: any;
  children?: any;
  buttons?: any[];
  type?: string;
  showHeader?: boolean;
}

const ModalConfirmation = (props: ModalConfirmationProps) => {
  const isMobile = window.innerWidth < 992;
  const { settings } = useSettings();
  const { t } = useTranslation();

  const showHeader = !props.hasOwnProperty("showHeader") || props.showHeader;

  return (
    <IonModal
      isOpen={props.isOpen}
      backdropDismiss={false}
      keyboardClose={false}
      onDidDismiss={() => props.onDidDismiss?.()}
      className={`modal ${props.type && "modal--" + props.type} ${props.classModifiers}`}
    >
      {props?.type !== "secondary" && showHeader && (
        <IonHeader>
          {isMobile && <img src={settings?.brand?.img_path_app_header_logo || "/assets/logo-white-icon.svg"} alt={`${t("instance")} logo`} className="header__logo" width="34px" />}
          <button className="modal__close" onClick={props.closeModal}>
            <FontAwesomeIcon icon={isMobile ? faXmark : faCircleXmark} />
          </button>
        </IonHeader>
      )}

      <div className="modal__inner">
        {(props.children || props.heading || props.text) && (
          <div className={"modal__content"}>
            {props.heading && <h2 className="modal__heading">{props.heading}</h2>}
            {props.children ? props.children : props.text && <div className="modal__text">{props.text}</div>}
          </div>
        )}
        {props.buttons && props.buttons.length >= 1 && (
          <div className={"modal__buttons"}>
            <ModalButtons buttons={props.buttons} />
          </div>
        )}
      </div>
    </IonModal>
  );
};

export default ModalConfirmation;
